import React, { useEffect, useState } from "react";
import { apiRequest } from "../../utils/api";
import { FieldError, inputErrorClass } from "./FormFeedback";

const CaptchaBox = ({ value, onChange, errors = {}, resetKey = 0 }) => {
  const [captcha, setCaptcha] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [loadError, setLoadError] = useState("");

  const loadCaptcha = () => {
    setIsLoading(true);
    setLoadError("");

    apiRequest("/captcha")
      .then((data) => {
        const nextCaptcha = data?.captcha ?? null;
        setCaptcha(nextCaptcha);
        onChange({ id: nextCaptcha?.id ?? "", answer: "" });
      })
      .catch(() => setLoadError("Unable to load CAPTCHA. Please refresh it."))
      .finally(() => setIsLoading(false));
  };

  useEffect(() => {
    loadCaptcha();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [resetKey]);

  return (
    <div className="captcha-box">
      <div className="captcha-box-head">
        <div>
          <label>Verification</label>
          <p>Answer this quick check to continue.</p>
        </div>
        <button type="button" onClick={loadCaptcha} disabled={isLoading}>
          {isLoading ? "Loading..." : "Refresh"}
        </button>
      </div>

      <div className="captcha-box-body">
        <div className="captcha-question">{captcha?.question || "Loading..."}</div>
        <input
          type="hidden"
          name="captcha_id"
          value={value?.id ?? ""}
        />
        <input
          type="text"
          name="captcha_answer"
          className={inputErrorClass(errors, "captcha_answer")}
          placeholder="Your answer"
          value={value?.answer ?? ""}
          onChange={(e) => onChange({ id: value?.id ?? captcha?.id ?? "", answer: e.target.value })}
          required
          inputMode="numeric"
        />
      </div>

      {loadError && <span className="epic-field-error">{loadError}</span>}
      <FieldError errors={errors} name="captcha_answer" />
    </div>
  );
};

export default CaptchaBox;
